export default "__VITE_ASSET__DooN4mtm__"